import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SlugifyPipe } from './slugify.pipe';
import { AbsoluteAnchorDirective } from './absolute-anchor.directive';
import { ContentfulImageDirective } from './contentful-image.directive';

@NgModule({
  declarations: [
    SlugifyPipe,
    ContentfulImageDirective,
    AbsoluteAnchorDirective,
  ],
  imports: [CommonModule],
  exports: [SlugifyPipe, ContentfulImageDirective, AbsoluteAnchorDirective],
})
export class DirectivesModule {}
